import { FCWithChildren } from 'common/types';
import { DropZone, FILE_TYPE } from 'components/Upload';
import { DropZoneEvent } from 'components/Upload/components/DropZone/types';
import { FileMimeType } from 'components/Upload/types';

import { FilePickerErrorCode } from './types';

interface FilePickerProps {
  acceptedTypes?: FileMimeType[];
  maxSize?: number;
  onError?: (errorType: FilePickerErrorCode, file: File) => void;
  onSelect: (file: File, eventMethod: DropZoneEvent) => void;
}

/**
 * This is a more generic file picker component than `Upload`
 * It basically only give access to local file via `onSelect`
 * and raises file types and max size errors via callbacks
 */
const FilePicker: FCWithChildren<FilePickerProps> = ({
  acceptedTypes = FILE_TYPE.ALLOWED_DOCUMENTS,
  children,
  maxSize,
  onError,
  onSelect,
}) => {
  const handleSelect = (file: File, eventMethod: DropZoneEvent) => {
    if (!acceptedTypes.includes(file.type as FileMimeType)) {
      onError?.('unsupportedFileType', file);
      return;
    }

    if (maxSize && file.size > maxSize) {
      onError?.('fileTooBig', file);
      return;
    }

    onSelect(file, eventMethod);
  };

  return (
    <DropZone accept={acceptedTypes.join(',')} onUpload={handleSelect}>
      {children}
    </DropZone>
  );
};

export default FilePicker;
